<template>
  <div class="home-page anim-fade-in-up">
    <!-- Hero 区 — 宽屏通栏 -->
    <div class="hero-card">
      <img src="../../assets/xiaohui.png" alt="校徽" class="hero-logo" />
      <h1 class="hero-title">SDU—HFLIBS 可视化分析系统</h1>
      <p class="hero-desc">山东大学 · 行星科学团队 — 面向HFLIBS实验的智能可视化分析平台</p>
      <hr class="rule-accent" />
    </div>

    <!-- 功能卡片 — 宽屏三列 -->
    <div class="feature-grid">
      <div v-for="(card, idx) in featureCards" :key="card.title" :class="['feature-card', 'card-gold-top', `stagger-${idx + 1}`]" style="animation: fadeInUp 0.4s ease-out both;">
        <i :class="card.icon" class="feature-icon"></i>
        <h3>{{ card.title }}</h3>
        <p>{{ card.desc }}</p>
      </div>
    </div>

    <!-- 快速开始 — 通栏 -->
    <div class="quick-card anim-fade-in-up stagger-4">
      <i class="el-icon-info"></i>
      <div>
        <strong>快速开始</strong>
        <p>请通过顶部导航栏选择功能模块。建议先在「计算机视觉设置」中加载YOLO模型，再进入「USB视频传输设置」接收视频流并进行实时分析。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.hero-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  padding: 48px 44px;
  text-align: center;
  margin-bottom: 28px;
}

.hero-logo {
  width: 64px; height: 64px; border-radius: 50%;
  margin-bottom: 18px;
}

.hero-title {
  font-family: var(--font-display);
  font-size: 2.2rem; font-weight: 500;
  color: var(--text-primary);
  margin: 0 0 8px;
  letter-spacing: 0.04em;
}

.hero-desc {
  font-size: 0.9rem; color: var(--text-muted);
  margin: 0 0 18px;
}

.rule-accent {
  width: 56px; height: 2px;
  background: var(--accent-primary);
  border: none;
  margin: 0 auto;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.feature-card {
  text-align: center;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  padding: 32px 24px;
  transition: box-shadow var(--transition-base), border-color var(--transition-base);
}

.feature-card:hover {
  box-shadow: var(--shadow-elevated);
  border-color: var(--border-default);
}

.feature-card h3 {
  font-family: var(--font-display);
  font-size: 1.1rem; font-weight: 500;
  color: var(--text-primary); margin: 16px 0 8px;
}

.feature-card p { font-size: 0.84rem; color: var(--text-muted); line-height: 1.6; margin: 0; }
.feature-icon { font-size: 2.2rem; color: var(--accent-primary); }

.quick-card {
  display: flex; align-items: flex-start; gap: 14px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  padding: 20px 28px;
}

.quick-card i {
  color: var(--accent-primary);
  font-size: 1.2rem; flex-shrink: 0; margin-top: 2px;
}

.quick-card strong {
  display: block;
  color: var(--text-primary);
  margin-bottom: 4px;
  font-size: 0.92rem;
  font-weight: 600;
}

.quick-card p { margin: 0; color: var(--text-secondary); font-size: 0.84rem; line-height: 1.6; }

@media screen and (max-width: 860px) {
  .feature-grid { grid-template-columns: 1fr; }
  .hero-card { padding: 32px 20px; }
  .hero-title { font-size: 1.5rem; }
}
</style>

<script>
export default {
  data() {
    return {
      featureCards: [
        { icon: 'el-icon-view', title: '计算机视觉', desc: 'YOLO模型浏览器端推理，颗粒实时检测与结果可视化' },
        { icon: 'el-icon-video-camera', title: '实验视频传输', desc: 'USB摄像头实时视频流接收、截屏、录制与本地分析' },
        { icon: 'el-icon-aim', title: '自动对焦', desc: 'HFLIBS镜头自动对焦控制，树莓派端自动校准镜头获取清晰图像' }
      ]
    }
  }
}
</script>
